module.exports = __webpack_public_path__ + "static/media/tennis.06229154.png";